'use strict';

/**
 * Pict-Provider-StickerSetAPI
 * ---------------------------
 * Browser-side client for custom sticker sets (/1.0/StickerSet[s]). Backs the "manage our stickers"
 * surface and the set pickers. Reads (listSets) are open to any signed-in user; create / update /
 * delete are gated server-side by stickers.manage.
 */

const libPictProvider = require('pict').ServiceProviderBase;
const libFrameworkClient = require('./FrameworkClient.js');

const _DefaultProviderConfiguration =
{
	ProviderIdentifier: 'StickerSetAPI',
	Dependencies: [],
	RoutePrefix: '/1.0/'
};

class PictProviderStickerSetAPI extends libPictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		let tmpOptions = Object.assign({}, _DefaultProviderConfiguration, pOptions || {});
		super(pFable, tmpOptions, pServiceHash);
		this.routePrefix = this.options.RoutePrefix;
	}

	_url(pPath)
	{
		let tmpPrefix = this.routePrefix;
		if (tmpPrefix.charAt(tmpPrefix.length - 1) !== '/') { tmpPrefix += '/'; }
		return tmpPrefix + pPath.replace(/^\//, '');
	}

	// Resolves to { System: [...summaries], Custom: [...sets with Items] }.
	listSets()
	{
		return libFrameworkClient.getJSON(this.fable, this._url('StickerSetLibrary'))
			.then((pBody) => (pBody ? pBody : { System: [], Custom: [] }))
			.catch(() => ({ System: [], Custom: [] }));
	}

	createSet(pName, pItems)
	{
		return this._write('POST', 'StickerSet/New', { Name: pName || '', Items: pItems || [] });
	}

	updateSet(pIDStickerSet, pPatch)
	{
		return this._write('PUT', 'StickerSet/' + (parseInt(pIDStickerSet, 10) || 0) + '/Save', pPatch || {});
	}

	renameSet(pIDStickerSet, pName) { return this.updateSet(pIDStickerSet, { Name: pName || '' }); }
	saveItems(pIDStickerSet, pItems) { return this.updateSet(pIDStickerSet, { Items: pItems || [] }); }

	deleteSet(pIDStickerSet)
	{
		return this._write('POST', 'StickerSet/' + (parseInt(pIDStickerSet, 10) || 0) + '/Remove', {});
	}

	_write(pMethod, pPath, pBody)
	{
		let tmpVerb = (pMethod === 'PUT') ? libFrameworkClient.putJSON : libFrameworkClient.postJSON;
		return tmpVerb(this.fable, this._url(pPath), pBody || {})
			.then((pJSON) =>
			{
				if (!pJSON || !pJSON.Success) { throw new Error((pJSON && pJSON.Error) || 'Request failed.'); }
				return pJSON;
			});
	}
}

module.exports = PictProviderStickerSetAPI;
module.exports.default_configuration = _DefaultProviderConfiguration;
